export default {
    scheme: 'macintosh',
    author: 'Rebecca Bettencourt (http://www.kreativekorp.com)',
    base00: '#000000',
    base01: '#404040',
    base02: '#404040',
    base03: '#808080',
    base04: '#808080',
    base05: '#c0c0c0',
    base06: '#c0c0c0',
    base07: '#ffffff',
    base08: '#dd0907',
    base09: '#ff6403',
    base0A: '#fbf305',
    base0B: '#1fb714',
    base0C: '#02abea',
    base0D: '#0000d3',
    base0E: '#4700a5',
    base0F: '#90713a',
};
